export default __webpack_public_path__ + "乳腺癌诊断.jpg";